module.exports = __webpack_public_path__ + "img/logitech.ff86d903.png";